import './App.css'
import './custom.scss'
import Hugo from './components/Hugo'

function App() {
  return <Hugo />
}

export default App
